export default "__VITE_ASSET__Bf2Pq6Db__"